import { Toaster as SonnerToaster, toast } from 'sonner';
import { useTheme } from '../lib/theme.js';

/**
 * Themed toast host. Mount once near the app root. Fire toasts with the re-exported
 * `toast` helper: toast.success('Saved'), toast.error(err.message), etc.
 */
export function Toaster() {
  const { theme } = useTheme();
  return (
    <SonnerToaster
      theme={theme}
      position="top-right"
      richColors
      closeButton
      toastOptions={{
        classNames: {
          toast:
            'group rounded-lg border border-border bg-popover text-popover-foreground shadow-lg',
        },
      }}
    />
  );
}

export { toast };
